import {
  renderThreadDeleteAction,
  renderThreadDetailDrawerShell,
  renderThreadDetailTurnsSection
} from "../detail-shared.js";

export function renderHarnessThreadDetailDrawer(detailState, options = {}) {
  const current = detailState.thread;
  if (!current) {
    return "";
  }

  const pendingCount = Object.values(detailState.decisionsByTurnID || {})
    .reduce((sum, items) => sum + items.filter((item) => item.state === "pending").length, 0);
  const workspaceDiagnostics = detailState.workspaceDiagnostics;
  const threadDiagnostics = detailState.threadDiagnostics;
  const renderContextRow = options.renderContextRow || (() => "");
  const lookupAgentName = options.lookupAgentName || ((value) => value || "unknown");
  const lookupWorkspaceName = options.lookupWorkspaceName || ((value) => value || "unknown");
  const renderTurns = options.renderTurns || (() => `<div class="empty">No turns yet.</div>`);

  return renderThreadDetailDrawerShell(`
    <div class="panel-eyebrow">Thread context</div>
    <div class="list">
      ${renderContextRow("Thread ID", current.id)}
      ${renderContextRow("Agent", lookupAgentName(current.agent_id))}
      ${renderContextRow("Workspace", lookupWorkspaceName(current.workspace_id))}
      ${renderContextRow("Workspace repo", workspaceDiagnostics?.repo_path || "n/a")}
      ${renderContextRow("Thread worktree", threadDiagnostics?.worktree_path || "n/a")}
      ${threadDiagnostics?.provider_session_id ? renderContextRow("Provider session", threadDiagnostics.provider_session_id) : ""}
      ${threadDiagnostics?.provider_thread_id ? renderContextRow("Provider thread", threadDiagnostics.provider_thread_id) : ""}
      ${renderContextRow("State", current.state)}
      ${renderContextRow("Merge state", current.merge_state || "open")}
      ${renderContextRow("Draft branch", current.draft_branch || "n/a")}
      ${renderContextRow("Last promotion", current.last_promotion_id || "n/a")}
      ${renderContextRow("Pending decisions", String(pendingCount))}
      ${renderContextRow("Last base ref", current.last_base_ref || "auto")}
      ${renderContextRow("Last head commit", current.last_head_commit || "n/a")}
      ${current.recovery_hint ? renderContextRow("Recovery hint", current.recovery_hint) : ""}
    </div>
    ${renderThreadDetailTurnsSection(renderTurns(detailState.turns))}
    ${renderThreadDeleteAction()}
  `);
}
